var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.22,
    viewBox: "0 0 20 20.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8857",
    "data-name": "Group 8857",
    transform: "translate(-1685.759 -4425.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 20,
    height: 20,
    transform: "translate(1685.759 4425.82)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M1715.2,4472.522h-8.173a.557.557,0,0,0-.557.557v6.333a.557.557,0,0,0,.557.557h8.174a.557.557,0,0,0,.557-.557v-6.333A.557.557,0,0,0,1715.2,4472.522Zm-.557,6.333h-7.059v-5.219h7.059Z",
    transform: "translate(-16.863 -37.927)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7249",
    "data-name": "Path 7249",
    d: "M1716.467,4485.112h4.37a.557.557,0,1,0,0-1.114h-4.37a.557.557,0,1,0,0,1.114Z",
    transform: "translate(-24.552 -47.272)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7250",
    "data-name": "Path 7250",
    d: "M1716.467,4495.844h2.885a.557.557,0,1,0,0-1.114h-2.885a.557.557,0,0,0,0,1.114Z",
    transform: "translate(-24.552 -56.011)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8855",
    "data-name": "Group 8855",
    transform: "translate(1686.313 4432.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7251",
    "data-name": "Path 7251",
    d: "M1707.6,4468.515v-.944a1.226,1.226,0,0,1-1.268-.8h-16.317a1.226,1.226,0,0,1-1.268.8v.944a1.23,1.23,0,1,1,0,2.449v.944a1.23,1.23,0,1,1,0,2.449v.943a1.227,1.227,0,0,1,1.33,1.042h16.193a1.227,1.227,0,0,1,1.33-1.042v-.943a1.23,1.23,0,1,1,0-2.449v-.943a1.23,1.23,0,1,1,0-2.449Zm-6.274,6.215a.557.557,0,0,1-.557.557h-8.174a.557.557,0,0,1-.557-.557V4468.4a.557.557,0,0,1,.557-.557h8.174a.557.557,0,0,1,.557.557Zm2.748-.085a.557.557,0,1,1-1.114,0v-5.893a.557.557,0,1,1,1.114,0Z",
    transform: "translate(-1688.744 -4466.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7252",
    "data-name": "Path 7252",
    d: "M1712.466,4483.74h7.059v-5.219h-7.059Zm1.2-4.2h4.37a.557.557,0,1,1,0,1.114h-4.37a.557.557,0,1,1,0-1.114Zm0,1.993h2.885a.557.557,0,1,1,0,1.114h-2.885a.557.557,0,0,1,0-1.114Z",
    transform: "translate(-1708.061 -4476.339)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8856",
    "data-name": "Group 8856",
    transform: "translate(1686.256 4425.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7253",
    "data-name": "Path 7253",
    d: "M1725.265,4459.22a.56.56,0,0,0-.125.194h1.107l-.194-.194A.557.557,0,0,0,1725.265,4459.22Z",
    transform: "translate(-1718.324 -4453.562)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7254",
    "data-name": "Path 7254",
    d: "M1714.357,4444.429l-2.941,2.94h1.576l1.759-1.759,1.759,1.759h1.575l-2.941-2.94A.557.557,0,0,0,1714.357,4444.429Z",
    transform: "translate(-1707.148 -4441.517)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7255",
    "data-name": "Path 7255",
    d: "M1695.643,4432.378a.557.557,0,0,1,.788,0l2.941,2.941h1.51l-5.521-5.521a1.225,1.225,0,0,1-1.461-.331l-.667.667a1.23,1.23,0,1,1-1.732,1.731l-.667.667a1.23,1.23,0,1,1-1.732,1.731l-.667.667a1.228,1.228,0,0,1,.309.387h3.959Z",
    transform: "translate(-1688.435 -4429.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7256",
    "data-name": "Path 7256",
    d: "M1746.721,4525.115a1.225,1.225,0,0,1,1.677.2l.667-.668a1.231,1.231,0,0,1-.381-.557H1745.7Z",
    transform: "translate(-1735.067 -4506.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7257",
    "data-name": "Path 7257",
    d: "M1721,4453.073a.558.558,0,0,1,.788,0l.194.194h1.438l-1.759-1.759-1.759,1.759h.973A.562.562,0,0,1,1721,4453.073Z",
    transform: "translate(-1714.058 -4447.415)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTicket);
export default __webpack_public_path__ + "static/media/white_ticket.1b6cd574198fe1ddcc1cca9352dabe70.svg";
export { ForwardRef as ReactComponent };